const FloodForecast = [
    {
        path: "/wcp/flood/forecast/result",
        name: "ForecastResult",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u9884\u62a5\u7ed3\u679c', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-result"),
        }
    },
    {
        path: "/wcp/flood/forecast/scheme",
        name: "ForecastScheme",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u65b9\u6848\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-scheme"),
        }
    },
    {
        path: "/wcp/flood/forecast/scheme/construction",
        name: "SchemeConstruction",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u65b9\u6848\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-scheme/scheme-construction"),
        }
    },
    {
        path: "/wcp/flood/forecast/scheme/accuracy/appraise",
        name: "SchemeAccuracyAppraise",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u65b9\u6848\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-scheme/scheme-appraise"),
        }
    },
    {
        path: "/wcp/flood/forecast/model",
        name: "Model",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u6a21\u578b\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-model"),
        }
    },
    {
        path: "/wcp/flood/forecast/model/modify",
        name: "ModelModify",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u6a21\u578b\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-model/model-modify"),
        }
    },
    {
        path: "/wcp/flood/forecast/calibration",
        name: "Calibration",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u53c2\u6570\u7387\u5b9a', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/param-calibration"),
        }
    },
    {
        path: "/wcp/flood/forecast/interactive/forecasting",
        name: "InteractiveForecast",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u4eba\u5de5\u9884\u62a5', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/interactive-forecast"),
        }
    },
    {
        path: "/wcp/flood/forecast/automatic/forecasting",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u81ea\u52a8\u9884\u62a5', requireAuth: true },
        name: "AutomaticForecast",
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/automatic-forecast"),
        }
    },
    {
        path: "/wcp/flood/forecast/automatic/forecasting/modify",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u81ea\u52a8\u9884\u62a5', requireAuth: true },
        name: "AutomaticForecastModify",
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/automatic-forecast/components/Modify"),
        }
    },
    {
        path: "/wcp/flood/forecast/forecasting/achievement",
        name: "ForecastAchievement",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u9884\u62a5\u6210\u679c', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-achievement"),
        }
    },
    {
        path: "/wcp/flood/forecast/forecasting/accuracy/appraise",
        name: "ForecastAccuracy",
        meta: { title: '\u6d2a\u6c34\u9884\u62a5\u002d\u4f5c\u4e1a\u9884\u62a5\u7cbe\u5ea6\u8bc4\u5b9a', requireAuth: true },
        components: {
            left: () => import("@/views/flood-forecast/navigation/NavigationBar"),
            main: () => import("@/views/flood-forecast/forecast-appraise"),
        }
    },
]

export default FloodForecast;


// WEBPACK FOOTER //
// ./src/router/flood-forecast.js